import React from 'react';

export default function IconMenuSetting() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_652_290)">
        <path
          d="M9 11.333C10.2887 11.333 11.3333 10.2884 11.3333 8.99972C11.3333 7.71105 10.2887 6.66638 9 6.66638C7.71133 6.66638 6.66666 7.71105 6.66666 8.99972C6.66666 10.2884 7.71133 11.333 9 11.333Z"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.5855 9.43528L14.4695 10.3193C14.666 10.5158 14.709 10.8227 14.5678 11.0622L13.5671 12.7934C13.4259 13.0329 13.1435 13.1495 12.8795 13.082L11.6762 12.7627C11.3508 12.6768 11.0132 12.8671 10.9272 13.1986L10.608 14.4019C10.5343 14.672 10.2949 14.8562 10.0125 14.8562H8.01107C7.7348 14.8562 7.48924 14.672 7.41557 14.4019L7.09633 13.1986C7.01038 12.8732 6.67272 12.6768 6.34734 12.7627L5.14405 13.082C4.87393 13.1556 4.59152 13.039 4.45646 12.7934L3.45577 11.0622C3.31456 10.8227 3.35754 10.5158 3.55399 10.3193L4.43804 9.43528C4.67747 9.19585 4.67747 8.80908 4.43804 8.56965L3.55399 7.6856C3.35754 7.48914 3.31456 7.18218 3.45577 6.94275L4.45646 5.21149C4.59766 4.97206 4.88007 4.85542 5.14405 4.92295L6.34734 5.24219C6.67272 5.32814 7.01038 5.13782 7.09633 4.8063L7.41557 3.60301C7.48924 3.33289 7.72867 3.14871 8.01107 3.14871H10.0125C10.2887 3.14871 10.5343 3.33289 10.608 3.60301L10.9272 4.8063C11.0132 5.13168 11.3508 5.32814 11.6762 5.24219L12.8795 4.92295C13.1496 4.84928 13.432 4.96592 13.5671 5.21149L14.5678 6.94275C14.709 7.18218 14.666 7.48914 14.4695 7.6856L13.5855 8.56965C13.3461 8.80908 13.3461 9.19585 13.5855 9.43528Z"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_652_290">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(2 2)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
